import { IParamsActivity } from '~/utils/interface/activity';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';

const activityApi = {
  getActivity(params: IParamsActivity) {
    const url = `api/admin/activities`;
    return axiosClient.get<IApiBaseResponse<any>>(url, { params });
  },
};

export default activityApi;
